module.exports = __webpack_public_path__ + "media/icons/map-icon-polygon-active-13078ae6.svg";